import React, { Component } from "react";
import { UserContext } from "../../Context";
import firebase from "../../utils/firebase";
import _ from "lodash";
import moment from "moment";

import {
  isValidNumber,
  // isValidDate,
  SecondaryColor,
  WhiteColor
  // GetDateFromTimestamp
} from "../../utils/consts";

import ApplyCardRentField from "../ApplyCardRentField/ApplyCardRentField";
import ApplyCardMoveInField from "../ApplyCardMoveInField/ApplyCardMoveInField";

import Button from "@atlaskit/button";
import StarFilledIcon from "@atlaskit/icon/glyph/star-filled";
import StarOutlineIcon from "@atlaskit/icon/glyph/star-outline";

const initState = {
  rentOffer: "",
  moveInDate: ""
};
export default class ApplyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initState,
      listing: this.props.listing
    };
  }

  componentDidMount() {
    const listing = this.state.listing || {};
    // console.log(listing);
    const expense = listing.expense || {};
    const rentExpense = expense.rentExpense;
    if (!!rentExpense) {
      const rentOffer = rentExpense.toString();
      // console.log("setting rentOffer");
      this.setState({ rentOffer });
    }
    const listingDate = listing.listingDate || {};
    const timestamp = listingDate.seconds || listingDate._seconds;
    // console.log(timestamp);
    const moveInDate = timestamp * 1000;
    // const moveInDate = GetDateFromTimestamp(timestamp);
    if (!!moveInDate) {
      // console.log(moveInDate);
      this.setState({ moveInDate });
    }
  }

  onChangeHandler = (item, value) => {
    this.setState({ [`${item}`]: value });
  };

  save = (uid, my) => {
    this.setState({ saving: true });
    const now = firebase.firestore.Timestamp.now();
    const rentOfferValue = this.state.rentOffer;
    const rentOffer = parseInt(rentOfferValue, 10);
    const moveInDate = this.state.moveInDate;
    const { listing } = this.state;
    const update = {
      lid: listing.lid,
      created: now,
      uid,
      rentOffer,
      moveInDate,
      updated: now,
      title: listing.title
    };
    const applicationPromise = firebase
      .firestore()
      .collection("application")
      .doc(uid)
      .set(update);
    let myApplicationPromise;
    if (_.isEmpty(my) || _.isEmpty(my.applications)) {
      myApplicationPromise = firebase
        .firestore()
        .collection("my")
        .doc(uid)
        .set(
          {
            applications: {
              [`${listing.lid}`]: {
                ...update,
                title: listing.title
              }
            }
          },
          { merge: true }
        );
    } else {
      myApplicationPromise = firebase
        .firestore()
        .collection("my")
        .doc(uid)
        .update({
          [`applications.${listing.lid}`]: {
            ...update,
            title: listing.title
          }
        });
    }
    Promise.all([applicationPromise, myApplicationPromise])
      .then(() => {
        this.setState({ saving: false });
        this.props.addFlag({
          appearance: 2,
          title: "Application Submitted"
        });
      })
      .catch(error => {
        this.setState({ saving: false });
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again."
        });
        console.log(error);
      });
  };

  validate = (uid, my) => {
    console.log(moment(null).isValid());
    const rentOfferValid = this.isRentalOffer(this.state.rentOffer);
    const moveInDateValid = this.isMoveInDate(this.state.moveInDate);

    const valid = [rentOfferValid, moveInDateValid, uid].every(item => item);
    if (!valid) {
      this.props.addFlag({
        appearance: 2,
        title: "Please complete all fields"
      });
      console.log("error: isValidNumber");
    } else {
      this.save(uid, my);
    }
  };

  isRentalOffer = number => isValidNumber(number);

  isMoveInDate = timestamp => moment(timestamp).isValid();
  // isMoveInDate = date =>
  //   isValidDate(moment(date).toDate()) && this.state.moveInDate.length !== 0;

  render() {
    // console.log(this.state);
    return (
      <UserContext.Consumer>
        {userContext => {
          const user = userContext.user || {};
          const uid = user.uid;
          const my = userContext.my || {};
          const listing = this.state.listing || {};
          const expense = listing.expense || {};
          const locationScore = listing.locationScore || {};
          const priceScore = listing.priceScore || {};
          const scores = { ...locationScore, ...priceScore };
          return (
            <div className="apply-card__apply-container">
              <div className="apply-card-expense">
                <p className="apply-card-expense__summary">
                  {expense.rentExpense && (
                    <span className="apply-card-expense__expense">
                      ${expense.rentExpense}{" "}
                      <span className="apply-card-expense__term">
                        per month
                      </span>
                    </span>
                  )}
                </p>
                <p>
                  <span className="apply-card-expense__average-score">
                    {_.times(
                      Math.floor(
                        Object.values(scores).reduce((a, b) => a + b, 0) /
                          (Object.keys(scores).length || 1) /
                          20
                      ),
                      1
                    ).map((e, i) => (
                      <StarFilledIcon
                        key={`apply-card-expense__average-score-icon_fillled-${i}`}
                        className="apply-card-expense__average-score-icon"
                        primaryColor={SecondaryColor}
                        size="small"
                        label="star"
                      />
                    ))}
                    {_.times(
                      5 -
                        Math.floor(
                          Object.values(scores).reduce((a, b) => a + b, 0) /
                            (Object.keys(scores).length || 1) /
                            20
                        ),
                      1
                    ).map((e, i) => (
                      <StarOutlineIcon
                        key={`apply-card-expense__average-score-icon_unfillled-${i}`}
                        className="apply-card-expense__average-score-icon"
                        primaryColor={SecondaryColor}
                        size="small"
                        label="unfilled star"
                      />
                    ))}
                  </span>
                </p>
              </div>
              <hr className="apply-card-section-break" />
              <div className="apply-card-form__form">
                <ApplyCardRentField
                  placeholder={`e.g. ${
                    !_.isEmpty(expense) ? expense.rentExpense : 2200
                  }`}
                  value={this.state.rentOffer || expense.rentExpense}
                  onChange={e => {
                    this.onChangeHandler("rentOffer", e.target.value);
                  }}
                  helperText={`Rental offer CAD? You can cancel at any time.`}
                />
                <ApplyCardMoveInField
                  label="Desired Move In Date"
                  helperText="When would you prefer to move in?"
                  placeholder={"2018/01/01"}
                  value={this.state.moveInDate}
                  onChange={value => {
                    this.onChangeHandler(
                      "moveInDate",
                      moment(value, "YYYY-MM-DD").valueOf()
                    );
                  }}
                />
              </div>
              <div className="apply-card-form__progress-container">
                <hr className="apply-card-section-break" />
                <div className="apply-card-form__progress-controls">
                  <Button
                    onClick={
                      !!userContext.user
                        ? () => this.validate(uid, my)
                        : userContext.loginModalHandler
                    }
                    appearance={"primary"}
                    isLoading={this.state.saving}
                    isDisabled={
                      !this.isMoveInDate(this.state.moveInDate) ||
                      !this.isRentalOffer(this.state.rentOffer)
                    }
                    style={{ color: WhiteColor }}
                    className="apply-card__apply-btn"
                  >
                    Reserve A Viewing
                  </Button>
                  <p className="apply-card__info-charge">
                    You will not be charged.
                  </p>
                  <p className="apply-card__info-charge">
                    You can cancel reservation at anytime.
                  </p>
                </div>
                <hr className="apply-card-section-break" />
                <p className="apply-card__info-nudge-summary">
                  This home is on people’s minds.
                </p>
                <p className="apply-card__info-nudge-details">
                  It’s been viewed 500+ times in the past week.
                </p>
              </div>
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ApplyForm/ApplyForm.js